import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-title-gray-700 menu-icon-muted menu-active-bg menu-state-primary fw-semibold py-4 fs-base w-200px",
  "data-kt-menu": "true",
  "data-kt-element": "theme-mode-menu"
}
const _hoisted_2 = { class: "menu-item px-3 my-0" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", {
  class: "menu-icon",
  "data-kt-element": "icon"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-3" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "bi bi-sun-fill" })
  ])
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "menu-title" }, "Light", -1)
const _hoisted_5 = [
  _hoisted_3,
  _hoisted_4
]
const _hoisted_6 = { class: "menu-item px-3 my-0" }
const _hoisted_7 = /*#__PURE__*/_createStaticVNode("<span class=\"menu-icon\" data-kt-element=\"icon\"><span class=\"svg-icon svg-icon-3\"><i class=\"bi bi-moon-fill\"></i></span></span><span class=\"menu-title\">Dark</span><span class=\"badge badge-light-warning fw-bold fs-8 px-2 py-1 ms-2\">Experimental</span>", 3)
const _hoisted_10 = [
  _hoisted_7
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("a", {
        class: _normalizeClass([{ active: _ctx.themeMode === 'light' }, "menu-link px-3 py-2"]),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setMode('light')))
      }, _hoisted_5, 2)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("a", {
        class: _normalizeClass([{ active: _ctx.themeMode === 'dark' }, "menu-link px-3 py-2"]),
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setMode('dark')))
      }, _hoisted_10, 2)
    ])
  ]))
}